import type { BasicIconProps as IconProps } from "./Icon";
import { IconWrapper } from "./Icon";

export const AppleIcon = (props: IconProps) => (
  <IconWrapper viewBox="0 0 20 24" {...props}>
    <svg>
      <path
        d="M19.3636 8.1816C19.2211 8.2896 16.7052 9.6744 16.7052 12.7536C16.7052 16.3152 19.9066 17.5752 20.0025 17.6064C19.9877 17.6832 19.4939 19.332 18.3145 21.012C17.2629 22.4904 16.1646 23.9664 14.4939 23.9664C12.8231 23.9664 12.3931 23.0184 10.4644 23.0184C8.58477 23.0184 7.91646 23.9976 6.38821 23.9976C4.85995 23.9976 3.79361 22.6296 2.56757 20.9496C1.14742 18.9768 0 15.912 0 13.0032C0 8.3376 3.10565 5.8632 6.16216 5.8632C7.78624 5.8632 9.14005 6.9048 10.1597 6.9048C11.1302 6.9048 12.6437 5.8008 14.4914 5.8008C15.1916 5.8008 17.7076 5.8632 19.3636 8.1816ZM13.6143 3.8256C14.3784 2.94 14.9189 1.7112 14.9189 0.4824C14.9189 0.312 14.9042 0.1392 14.8722 0C13.629 0.0456 12.1499 0.8088 11.258 1.8192C10.5577 2.5968 9.90418 3.8256 9.90418 5.0712C9.90418 5.2584 9.93612 5.4456 9.95086 5.5056C10.0295 5.52 10.1572 5.5368 10.285 5.5368C11.4005 5.5368 12.8034 4.8072 13.6143 3.8256Z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const FacebookIcon = (props: IconProps) => (
  <IconWrapper size={40} viewBox="0 0 40 40" {...props}>
    <svg>
      <g id="Facebook Logo" clipPath="url(#clip0_3590_1017)">
        <circle id="Ellipse 191" cx="20" cy="20" r="20" fill="white" />
        <path
          id="Vector"
          d="M40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 29.9824 7.31367 38.2566 16.875 39.757V25.7813H11.7969V20H16.875V15.5938C16.875 10.5813 19.8609 7.8125 24.4293 7.8125C26.6176 7.8125 28.9062 8.20312 28.9062 8.20312V13.125H26.3844C23.9 13.125 23.125 14.6668 23.125 16.2484V20H28.6719L27.7852 25.7813H23.125V39.757C32.6863 38.2566 40 29.9828 40 20Z"
          fill="#1877F2"
        />
      </g>
      <defs>
        <clipPath id="clip0_3590_1017">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </IconWrapper>
);

export const FacebookMinimalIcon = (props: IconProps) => (
  <IconWrapper size={20} viewBox="0 0 9 20" {...props}>
    <svg
      width="9px"
      height="20px"
      viewBox="0 0 9 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.985 21V10.999h2.662L9 7.552H5.985l.004-1.725c0-.899.082-1.38 1.328-1.38H8.98V1H6.318C3.12 1 1.994 2.672 1.994 5.484v2.069H0v3.446h1.994V21h3.99z"
        transform="translate(-1225 -87) translate(1225 86)"
        fill={props.fill}
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  </IconWrapper>
);

export const FacebookMessengerIcon = (props: IconProps) => (
  <IconWrapper size={40} viewBox="0 0 41 40" {...props}>
    <svg>
      <g id="Facebook_Messenger_logo_2020 1" clipPath="url(#clip0_3590_1588)">
        <path
          id="Vector"
          d="M20.3333 0C9.06825 0 0.333252 8.255 0.333252 19.4C0.333252 25.23 2.72325 30.27 6.61325 33.75C6.93825 34.04 7.13825 34.45 7.14825 34.89L7.25825 38.45C7.26626 38.7119 7.33849 38.9679 7.46859 39.1954C7.59868 39.4229 7.78266 39.6149 8.00436 39.7547C8.22606 39.8944 8.47869 39.9775 8.74005 39.9968C9.0014 40.016 9.26348 39.9708 9.50325 39.865L13.4733 38.115C13.8083 37.965 14.1883 37.94 14.5433 38.035C16.3683 38.535 18.3083 38.805 20.3333 38.805C31.5983 38.805 40.3333 30.55 40.3333 19.405C40.3333 8.26 31.5983 0 20.3333 0Z"
          fill="url(#paint0_radial_3590_1588)"
        />
        <path
          id="Vector_2"
          d="M8.32315 25.075L14.1981 15.755C14.4192 15.4041 14.7105 15.1028 15.0538 14.8702C15.3971 14.6376 15.7849 14.4787 16.1928 14.4035C16.6006 14.3284 17.0196 14.3386 17.4232 14.4335C17.8269 14.5284 18.2066 14.706 18.5381 14.955L23.2131 18.46C23.4219 18.6162 23.6758 18.7003 23.9365 18.6994C24.1972 18.6985 24.4505 18.6127 24.6581 18.455L30.9681 13.665C31.8081 13.025 32.9081 14.035 32.3481 14.93L26.4681 24.245C26.2471 24.5959 25.9558 24.8971 25.6125 25.1298C25.2692 25.3624 24.8814 25.5213 24.4735 25.5965C24.0657 25.6716 23.6467 25.6614 23.243 25.5665C22.8394 25.4716 22.4597 25.294 22.1281 25.045L17.4531 21.54C17.2444 21.3837 16.9905 21.2997 16.7298 21.3006C16.4691 21.3015 16.2158 21.3873 16.0081 21.545L9.69815 26.335C8.85815 26.975 7.75815 25.97 8.32315 25.075Z"
          fill="white"
        />
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_3590_1588"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.03325 40) scale(44 44)"
        >
          <stop stopColor="#0099FF" />
          <stop offset="0.6" stopColor="#A033FF" />
          <stop offset="0.9" stopColor="#FF5280" />
          <stop offset="1" stopColor="#FF7061" />
        </radialGradient>
        <clipPath id="clip0_3590_1588">
          <rect
            width="40"
            height="40"
            fill="white"
            transform="translate(0.333252)"
          />
        </clipPath>
      </defs>
    </svg>
  </IconWrapper>
);

export const GoogleIcon = (props: IconProps) => (
  <IconWrapper width={24} height={26} viewBox="0 0 24 26" {...props}>
    <svg>
      <path
        d="M11.24 12.28L0.599976 23.58C0.929976 24.81 2.04998 25.71 3.37998 25.71C3.90998 25.71 4.40998 25.57 4.83998 25.31L4.86998 25.29L16.85 18.38L11.24 12.27V12.28Z"
        fill="#EA4335"
      />
      <path
        d="M22.02 10.36H22.01L16.84 7.34998L11.01 12.54L16.86 18.39L22.01 15.42C22.91 14.93 23.52 13.98 23.52 12.89C23.52 11.8 22.92 10.85 22.02 10.37V10.36Z"
        fill="#FBBC04"
      />
      <path
        d="M0.6 2.14001C0.54 2.38001 0.5 2.62001 0.5 2.88001V22.85C0.5 23.11 0.53 23.35 0.6 23.59L11.61 12.58L0.6 2.14001Z"
        fill="#4285F4"
      />
      <path
        d="M11.32 12.86L16.83 7.35L4.85998 0.41C4.42998 0.15 3.91998 0 3.36998 0C2.04998 0 0.919976 0.91 0.599976 2.13L11.33 12.85L11.32 12.86Z"
        fill="#34A853"
      />
    </svg>
  </IconWrapper>
);

export const IMessageIcon = (props: IconProps) => (
  <IconWrapper size={40} viewBox="0 0 41 40" {...props}>
    <svg>
      <g id="iMessage Logo">
        <g clipPath="url(#clip0_3590_996)">
          <g id="g963">
            <path
              id="rect826"
              d="M31.8572 0H9.47627C4.61091 0 0.666748 3.94416 0.666748 8.80953V31.1905C0.666748 36.0558 4.61091 40 9.47627 40H31.8572C36.7226 40 40.6667 36.0558 40.6667 31.1905V8.80953C40.6667 3.94416 36.7226 0 31.8572 0Z"
              fill="url(#paint0_linear_3590_996)"
            />
            <path
              id="path922"
              d="M20.6668 8.87781C17.3516 8.87783 14.1722 9.97477 11.8279 11.9273C9.48374 13.8799 8.16677 16.5281 8.16675 19.2895C8.16977 21.0856 8.73058 22.8505 9.79467 24.4127C10.8588 25.9749 12.39 27.2813 14.2394 28.2048C13.7468 29.3076 13.0081 30.3417 12.0537 31.2643C13.9045 30.9394 15.6418 30.2569 17.1305 29.2699C18.2784 29.554 19.4693 29.6992 20.6668 29.7012C23.982 29.7012 27.1614 28.6042 29.5056 26.6516C31.8498 24.6991 33.1668 22.0508 33.1668 19.2895C33.1668 16.5281 31.8498 13.8799 29.5056 11.9273C27.1614 9.97477 23.982 8.87783 20.6668 8.87781Z"
              fill="white"
            />
          </g>
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_3590_996"
          x1="20.9842"
          y1="37.3448"
          x2="20.9842"
          y2="4.96419"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0CBD2A" />
          <stop offset="1" stopColor="#5BF675" />
        </linearGradient>
        <clipPath id="clip0_3590_996">
          <rect x="0.666748" width="40" height="40" rx="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </IconWrapper>
);

export const InstagramIcon = (props: IconProps) => (
  <IconWrapper size={40} viewBox="0 0 40 40" {...props}>
    <svg>
      <g id="Instagram Logo">
        <g clipPath="url(#clip0_3590_975)">
          <path
            id="Vector"
            d="M20.0065 0C11.6567 0 9.21471 0.00861611 8.74003 0.0480041C7.02651 0.190478 5.96025 0.460347 4.79862 1.03886C3.9034 1.48351 3.19738 1.99894 2.50059 2.72146C1.2316 4.03911 0.462511 5.66017 0.184102 7.5871C0.048743 8.52257 0.00936576 8.71335 0.00136726 13.4916C-0.00170908 15.0844 0.00136726 17.1805 0.00136726 19.9922C0.00136726 28.3375 0.0105963 30.7777 0.0505888 31.2516C0.189024 32.9194 0.450514 33.9687 1.00426 35.1165C2.06252 37.3136 4.08368 38.963 6.46477 39.5784C7.28923 39.7908 8.19983 39.9077 9.36884 39.9631C9.86413 39.9846 14.9124 40 19.9638 40C25.0151 40 30.0665 39.9938 30.5495 39.9692C31.9031 39.9055 32.6891 39.8 33.5581 39.5753C35.9546 38.9568 37.9389 37.3321 39.0186 35.1042C39.5616 33.9841 39.837 32.8948 39.9615 31.314C39.9886 30.9694 40 25.4745 40 19.9869C40 14.4985 39.9877 9.01369 39.9606 8.66904C39.8345 7.06275 39.5592 5.98266 38.9986 4.84102C38.5387 3.90648 38.0281 3.20858 37.2867 2.49498C35.9635 1.23087 34.3454 0.461578 32.4171 0.1834C31.4828 0.0483118 31.2967 0.0083084 26.5161 0H20.0065Z"
            fill="url(#paint0_radial_3590_975)"
          />
          <path
            id="Vector_2"
            d="M20.0065 0C11.6567 0 9.21471 0.00861611 8.74003 0.0480041C7.02651 0.190478 5.96025 0.460347 4.79862 1.03886C3.9034 1.48351 3.19738 1.99894 2.50059 2.72146C1.2316 4.03911 0.462511 5.66017 0.184102 7.5871C0.048743 8.52257 0.00936576 8.71335 0.00136726 13.4916C-0.00170908 15.0844 0.00136726 17.1805 0.00136726 19.9922C0.00136726 28.3375 0.0105963 30.7777 0.0505888 31.2516C0.189024 32.9194 0.450514 33.9687 1.00426 35.1165C2.06252 37.3136 4.08368 38.963 6.46477 39.5784C7.28923 39.7908 8.19983 39.9077 9.36884 39.9631C9.86413 39.9846 14.9124 40 19.9638 40C25.0151 40 30.0665 39.9938 30.5495 39.9692C31.9031 39.9055 32.6891 39.8 33.5581 39.5753C35.9546 38.9568 37.9389 37.3321 39.0186 35.1042C39.5616 33.9841 39.837 32.8948 39.9615 31.314C39.9886 30.9694 40 25.4745 40 19.9869C40 14.4985 39.9877 9.01369 39.9606 8.66904C39.8345 7.06275 39.5592 5.98266 38.9986 4.84102C38.5387 3.90648 38.0281 3.20858 37.2867 2.49498C35.9635 1.23087 34.3454 0.461578 32.4171 0.1834C31.4828 0.0483118 31.2967 0.0083084 26.5161 0H20.0065Z"
            fill="url(#paint1_radial_3590_975)"
          />
          <path
            id="Vector_3"
            d="M20.0074 8.72717C16.9459 8.72717 16.5617 8.74056 15.3593 8.79528C14.1592 8.85023 13.34 9.04023 12.6232 9.31899C11.8818 9.60692 11.2529 9.99207 10.6263 10.6189C9.99925 11.2455 9.6141 11.8744 9.32523 12.6156C9.04576 13.3326 8.85553 14.1519 8.80151 15.3515C8.74773 16.554 8.73364 16.9384 8.73364 19.9999C8.73364 23.0614 8.74726 23.4444 8.80175 24.6468C8.85694 25.8469 9.04693 26.6661 9.32547 27.3828C9.61363 28.1243 9.99878 28.7532 10.6256 29.3798C11.2519 30.0068 11.8809 30.3929 12.6218 30.6808C13.3391 30.9596 14.1585 31.1496 15.3583 31.2045C16.5608 31.2592 16.9447 31.2726 20.006 31.2726C23.0678 31.2726 23.4508 31.2592 24.6532 31.2045C25.8533 31.1496 26.6734 30.9596 27.3907 30.6808C28.1319 30.3929 28.7599 30.0068 29.3862 29.3798C30.0133 28.7532 30.3984 28.1243 30.6873 27.3831C30.9644 26.6661 31.1546 25.8467 31.211 24.6471C31.265 23.4447 31.2791 23.0614 31.2791 19.9999C31.2791 16.9384 31.265 16.5542 31.211 15.3518C31.1546 14.1517 30.9644 13.3326 30.6873 12.6158C30.3984 11.8744 30.0133 11.2455 29.3862 10.6189C28.7591 9.99183 28.1321 9.60668 27.39 9.31899C26.6713 9.04023 25.8517 8.85023 24.6516 8.79528C23.4492 8.74056 23.0664 8.72717 20.0039 8.72717H20.0074ZM18.9962 10.7586C19.2963 10.7581 19.6312 10.7586 20.0074 10.7586C23.0173 10.7586 23.374 10.7694 24.5626 10.8234C25.6617 10.8737 26.2582 11.0573 26.6556 11.2116C27.1817 11.416 27.5567 11.6602 27.951 12.0547C28.3456 12.4493 28.5898 12.825 28.7946 13.3511C28.9489 13.748 29.1328 14.3445 29.1828 15.4436C29.2368 16.6319 29.2486 16.9889 29.2486 19.9973C29.2486 23.0057 29.2368 23.3627 29.1828 24.551C29.1326 25.6501 28.9489 26.2466 28.7946 26.6435C28.5903 27.1696 28.3456 27.5442 27.951 27.9385C27.5565 28.333 27.1819 28.5773 26.6556 28.7816C26.2587 28.9366 25.6617 29.1198 24.5626 29.17C23.3742 29.224 23.0173 29.2358 20.0074 29.2358C16.9973 29.2358 16.6406 29.224 15.4523 29.17C14.3532 29.1193 13.7566 28.9357 13.359 28.7814C12.833 28.577 12.4572 28.3328 12.0627 27.9383C11.6681 27.5437 11.4239 27.1689 11.2191 26.6426C11.0648 26.2457 10.8809 25.6492 10.8309 24.5501C10.7768 23.3618 10.766 23.0048 10.766 19.9945C10.766 16.9842 10.7768 16.6291 10.8309 15.4408C10.8811 14.3417 11.0648 13.7452 11.2191 13.3478C11.4234 12.8218 11.6681 12.446 12.0627 12.0515C12.4572 11.6569 12.833 11.4127 13.359 11.2079C13.7564 11.0529 14.3532 10.8697 15.4523 10.8192C16.4922 10.7722 16.8952 10.7581 18.9962 10.7558V10.7586ZM26.0248 12.6304C25.278 12.6304 24.672 13.2356 24.672 13.9826C24.672 14.7294 25.278 15.3353 26.0248 15.3353C26.7716 15.3353 27.3775 14.7294 27.3775 13.9826C27.3775 13.2358 26.7716 12.6299 26.0248 12.6299V12.6304ZM20.0074 14.2109C16.8104 14.2109 14.2184 16.8029 14.2184 19.9999C14.2184 23.1969 16.8104 25.7877 20.0074 25.7877C23.2045 25.7877 25.7956 23.1969 25.7956 19.9999C25.7956 16.8029 23.2045 14.2109 20.0074 14.2109ZM20.0074 16.2423C22.0826 16.2423 23.765 17.9245 23.765 19.9999C23.765 22.075 22.0826 23.7575 20.0074 23.7575C17.932 23.7575 16.2498 22.075 16.2498 19.9999C16.2498 17.9245 17.932 16.2423 20.0074 16.2423Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_3590_975"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10.6251 43.0808) rotate(-90) scale(39.643 36.8711)"
        >
          <stop stopColor="#FFDD55" />
          <stop offset="0.1" stopColor="#FFDD55" />
          <stop offset="0.5" stopColor="#FF543E" />
          <stop offset="1" stopColor="#C837AB" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_3590_975"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-6.70021 2.88153) rotate(78.6806) scale(17.7206 73.0449)"
        >
          <stop stopColor="#3771C8" />
          <stop offset="0.128" stopColor="#3771C8" />
          <stop offset="1" stopColor="#6600FF" stopOpacity="0" />
        </radialGradient>
        <clipPath id="clip0_3590_975">
          <rect width="40" height="40" rx="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </IconWrapper>
);

export const InstagramMinimalIcon = (props: IconProps) => (
  <IconWrapper size={22} viewBox="0 0 22 22" {...props}>
    <svg>
      <path
        d="M61.001 0h-.003c2.988 0 3.362.013 4.535.066 1.17.054 1.97.24 2.672.511a5.382 5.382 0 011.948 1.269 5.399 5.399 0 011.27 1.949c.27.699.456 1.498.51 2.67C71.987 7.637 72 8.012 72 11s-.014 3.361-.066 4.535c-.055 1.17-.241 1.97-.512 2.67a5.4 5.4 0 01-1.27 1.948 5.382 5.382 0 01-1.946 1.27c-.7.272-1.5.457-2.672.51-1.173.054-1.547.067-4.534.067-2.988 0-3.362-.013-4.536-.066-1.17-.054-1.97-.24-2.67-.512a5.386 5.386 0 01-1.948-1.27 5.39 5.39 0 01-1.268-1.948c-.272-.7-.458-1.498-.512-2.67C50.013 14.362 50 13.988 50 11s.014-3.363.066-4.536c.053-1.17.239-1.97.511-2.67a5.4 5.4 0 011.27-1.948A5.386 5.386 0 0153.795.577c.7-.272 1.5-.457 2.67-.51C57.64.012 58.014 0 61.001 0zm-.987 1.982V1.98c-2.05.002-2.443.016-3.458.061-1.072.05-1.655.228-2.043.38-.513.2-.88.438-1.265.823a3.408 3.408 0 00-.823 1.265c-.15.388-.33.97-.379 2.042-.052 1.16-.063 1.506-.063 4.444 0 2.937.01 3.286.063 4.445.05 1.073.229 1.655.38 2.042.2.514.437.88.822 1.264.385.385.752.624 1.265.823.388.15.97.33 2.043.38 1.16.052 1.508.063 4.445.063 2.937 0 3.285-.011 4.445-.064 1.073-.049 1.655-.228 2.042-.379.514-.2.88-.437 1.264-.822.385-.385.624-.75.824-1.264.15-.387.33-.97.378-2.042.053-1.16.065-1.508.065-4.444 0-2.935-.012-3.283-.065-4.443-.048-1.073-.228-1.655-.378-2.042a3.42 3.42 0 00-.824-1.265 3.402 3.402 0 00-1.264-.823c-.387-.15-.97-.33-2.042-.378-1.16-.053-1.508-.064-4.445-.064h-.987zm6.859 1.827a1.32 1.32 0 110 2.64 1.32 1.32 0 010-2.64zM61 5.35a5.649 5.649 0 110 11.298 5.649 5.649 0 010-11.297zm0 1.982a3.667 3.667 0 100 7.333 3.667 3.667 0 000-7.333z"
        transform="translate(-1275 -86) translate(1225 86)"
        fill="#FFF"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  </IconWrapper>
);

export const WhatsAppIcon = (props: IconProps) => (
  <IconWrapper
    size={40}
    viewBox="-7 -7 39 39"
    style={{ backgroundColor: "#30D170", borderRadius: "40px" }}
    {...props}
  >
    <svg>
      <g id="Frame" clipPath="url(#clip0_3590_1404)">
        <g id="b">
          <path
            id="Vector"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.4163 3.90604C19.0665 1.56437 15.9412 0.273896 12.6115 0.272705C5.74979 0.272705 0.165865 5.82985 0.163473 12.6602C0.162875 14.8435 0.735677 16.9751 1.82508 18.8537L0.0588379 25.2727L6.65742 23.5501C8.47568 24.537 10.5223 25.0572 12.6061 25.0578H12.6115C19.4719 25.0578 25.0564 19.5001 25.0594 12.6697C25.0606 9.35961 23.7673 6.24711 21.4169 3.90544L21.4163 3.90604ZM12.6115 22.9656H12.6073C10.7507 22.965 8.93009 22.4685 7.34144 21.5304L6.96355 21.3072L3.04781 22.3293L4.09297 18.5299L3.84722 18.1406C2.81164 16.5013 2.26454 14.6066 2.26514 12.6608C2.26753 6.98342 6.90855 2.36497 12.6156 2.36497C15.3792 2.36616 17.9765 3.43818 19.9299 5.38461C21.8833 7.33104 22.9584 9.91794 22.9572 12.6691C22.9548 18.3465 18.3138 22.9656 12.6109 22.9656H12.6115ZM18.2863 15.2543C17.9753 15.0995 16.4459 14.3507 16.1607 14.2471C15.8755 14.1435 15.668 14.0923 15.4611 14.4019C15.2536 14.712 14.6575 15.409 14.4763 15.6156C14.2952 15.8221 14.1134 15.8477 13.8025 15.6929C13.4916 15.5382 12.4895 15.2114 11.3014 14.1566C10.377 13.3358 9.75282 12.3221 9.57106 12.012C9.38929 11.7019 9.55193 11.5346 9.70738 11.3804C9.84729 11.2418 10.0183 11.0191 10.1738 10.8382C10.3292 10.6572 10.3812 10.5281 10.4847 10.3215C10.5881 10.115 10.5367 9.93402 10.459 9.77925C10.3812 9.62449 9.7594 8.10068 9.49991 7.48104C9.24759 6.87747 8.99108 6.95901 8.80035 6.94949C8.61918 6.94056 8.4117 6.93878 8.20423 6.93878C7.99675 6.93878 7.66012 7.01616 7.37492 7.32628C7.08971 7.6364 6.28612 8.38521 6.28612 9.90842C6.28612 11.4316 7.40063 12.9037 7.55609 13.1102C7.71154 13.3168 9.74924 16.4435 12.8692 17.784C13.6112 18.1031 14.1905 18.2935 14.642 18.4358C15.387 18.6715 16.065 18.6382 16.6013 18.5584C17.1987 18.4697 18.4417 17.8096 18.7006 17.0864C18.9595 16.3632 18.9595 15.7435 18.8818 15.6144C18.8041 15.4852 18.5966 15.4078 18.2857 15.2531L18.2863 15.2543Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3590_1404">
          <rect
            width="25"
            height="25"
            fill="white"
            transform="translate(0.0605469 0.272705)"
          />
        </clipPath>
      </defs>
    </svg>
  </IconWrapper>
);

export const XIcon = (props: IconProps) => (
  <IconWrapper size={40} viewBox="0 0 40 40" {...props}>
    <svg>
      <g id="X Logo">
        <rect width="40" height="40" rx="20" fill="white" />
        <path
          id="Vector"
          d="M22.724 18.2084L31.2192 8.33337H29.2061L21.8297 16.9077L15.9382 8.33337H9.14307L18.0522 21.2993L9.14307 31.6547H11.1563L18.9459 22.5999L25.1678 31.6547H31.963L22.7235 18.2084H22.724ZM19.9666 21.4135L19.064 20.1224L11.8817 9.84889H14.9738L20.77 18.1399L21.6727 19.431L29.2071 30.2081H26.1149L19.9666 21.414V21.4135Z"
          fill="black"
        />
      </g>
    </svg>
  </IconWrapper>
);

export const XMinimalIcon = (props: IconProps) => (
  <IconWrapper size={20} viewBox="0 0 20 21" {...props}>
    <svg>
      <path
        d="M11.903 8.655L19.348 0h-1.764l-6.465 7.515L5.955 0H0l7.808 11.364L0 20.439h1.764l6.828-7.935 5.452 7.935H20L11.902 8.655zm-2.417 2.809l-.791-1.132L2.4 1.328h2.71l5.08 7.267.791 1.131 6.604 9.446h-2.71l-5.389-7.708z"
        fill="#fff"
      />
    </svg>
  </IconWrapper>
);
